import React, { Component } from 'react';
import { Field } from 'redux-form';
import classNames from 'classnames';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Grid, Row, Col, Panel, Button, ButtonToolbar, Input, Breadcrumb } from 'react-bootstrap';
import { Translate, I18n } from 'react-redux-i18n';
import moment from 'moment';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import { UI_HEIGHT } from '../Common/constants';
import CashFormatter from '../Common/cashFormatter';
import Spinner from '../../components/Widgets/spinner';
import { Selection } from '../Common/selection';
import { InputField } from '../Common/inputField';
import { DatePicker, DisabledDatePicker } from '../Common/datePicker';
import { dateFormat } from '../Common/cleanDates';
import checkPermission from '../Common/permissions';
import { companyCodeTitle, isGGI, isVAK, isSDR, isCRW, isSC } from '../../actions/root_url';

const getBsStyle = (input, value) => {
  return input === value ? 'success' : 'primary'
};

let renderRadios = (props) => {
  const titleClass = classNames({ 'parsley-error-label': props.meta.touched && props.meta.error }, 'control-label', 'col-sm-3', 'centerStyle')
  const renderStartDatePicker = (days) => {
    if (days === '-1') {
      return (
        <Button bsStyle="primary">
          <Field name="FromDate" placeholder={'Start'} component={DatePicker} />
        </Button>
      );
    }
    return (
      <Button bsStyle="primary">
        <Field name="FromDate" placeholder={'Start'} component={DisabledDatePicker} />
      </Button>
    );
  }
  const renderEndDatePicker = (days) => {
    if (days === '-1') {
      return (
        <Button bsStyle="primary">
          <Field name="ToDate" placeholder={'End'} component={DatePicker} />
        </Button>
      );
    }
    return (
      <Button bsStyle="primary">
        <Field name="ToDate" placeholder={'End'} component={DisabledDatePicker} />
      </Button>
    );
  }
  return (
    <ButtonToolbar className="radio-filter-buttons">
      <Button bsStyle={getBsStyle(props.input.value, '1')}>
        <div className="radio">
          <label htmlFor="today-radio-filter">
            <input {...props.input} id="today-radio-filter" type="radio" name="dateFilterRadios" value="1" checked={props.input.value === '1'} />
            <Translate value="today" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, '7')}>
        <div className="radio">
          <label htmlFor="sevenDay-radio-filter">
            <input {...props.input} id="sevenDay-radio-filter" type="radio" name="dateFilterRadios" value="7" checked={props.input.value === '7'} />
            7 <Translate value="days" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, '30')}>
        <div className="radio">
          <label htmlFor="thirtyDay-radio-filter">
            <input {...props.input} id="thirtyDay-radio-filter" type="radio" name="dateFilterRadios" value="30" checked={props.input.value === '30'} />
            30 <Translate value="days" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, '90')}>
        <div className="radio">
          <label htmlFor="ninetyDay-radio-filter">
            <input {...props.input} id="ninetyDay-radio-filter" type="radio" name="dateFilterRadios" value="90" checked={props.input.value === '90'} />
            90 <Translate value="days" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, '-1')}>
        <div className="radio">
          <label htmlFor="dateRange-radio-filter">
            <input {...props.input} id="dateRange-radio-filter" type="radio" name="dateFilterRadios" value="-1" checked={props.input.value === '-1'} />
            <Translate value="date_range" />
          </label>
        </div>
      </Button>
      {renderStartDatePicker(props.Days)}
      {renderEndDatePicker(props.Days)}
      {/* <Button
        bsStyle="primary"
        className="search-btn"
        type="submit"
        onClick={() =>{ props.fetchSalesOrdersByCustomerNum(props.CustomerId); }}>
        <em className="fa fa-search" />
      </Button> */}
    </ButtonToolbar>
  );
};

let renderStatusRadios = (props) => {
  return (
    <ButtonToolbar className="radio-filter-buttons">
      <Button bsStyle={getBsStyle(props.input.value, 'all')}>
        <div className="radio">
          <label htmlFor="all-radio-filter">
            <input {...props.input} id="all-radio-filter" type="radio" name="statusFilterRadios" value="all" checked={props.input.value === 'all'} />
            <Translate value="all" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, 'Return')}>
        <div className="radio">
          <label htmlFor="released-radio-filter">
            <input {...props.input} id="released-radio-filter" type="radio" name="statusFilterRadios" value="Return" checked={props.input.value === 'Return'} />
            <Translate value="return" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, 'Credit')}>
        <div className="radio">
          <label htmlFor="released-radio-filter">
            <input {...props.input} id="released-radio-filter" type="radio" name="statusFilterRadios" value="Credit" checked={props.input.value === 'Credit'} />
            <Translate value="credit" />
          </label>
        </div>
      </Button>
    </ButtonToolbar>
  );
};

let renderFormTypes = (props) => {
  return (
    <div className="optionStyle">
      <Col sm={3}>
        <label>
          <Input {...props.input} type="radio" value="invoice" />
          <Translate value="invoice" />
        </label>
      </Col>
      <Col sm={3}>
        <label>
          <Input {...props.input} type="radio" value="return" />
          <Translate value="return" />
        </label>
      </Col>
      <Col sm={3}>
        <label>
          <Input {...props.input} type="radio" value="credit" />
          <Translate value="credit" />
        </label>
      </Col>
      <Col sm={3}>
        <label>
          <Input {...props.input} type="radio" value="all" />
          <Translate value="all" />
        </label>
      </Col>
    </div>
  );
}

class CustomerReturn extends Component {
  static contextTypes = {
    router: React.PropTypes.object
  };

  constructor() {
    super();
    this.state = {
      tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton,

      invoices: {
        rows: [],
        selectedRows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null
      },

      isSelected: false,
      curRow: false,
      fromDate: null,
      toDate: null,
    };

    this.handleResize = this.handleResize.bind(this);
    this.fetchSalesOrdersByDetails = this.fetchSalesOrdersByDetails.bind(this);
    this.fetchSalesOrdersByCustomerNum = this.fetchSalesOrdersByCustomerNum.bind(this);
  }

  componentWillMount() {
    this.props.setDefaultDays('customerReturn');
    this.props.setValue('customerReturn', 'Status', 'all');
    this.props.fetchCustomers(() => {}, this.props.selectedCompany && this.props.selectedCompany.value);
    this.fetchSalesOrdersByCustomerNum(null);
  }

  componentDidMount() {
    document.title = companyCodeTitle;
    window.addEventListener('resize', this.handleResize);
    this.props.setDefaultDays('customerReturn');
    if (isVAK && this.props.selectedWarehouse && Object.keys(this.props.selectedWarehouse).length > 0) {
      this.fetchSalesOrdersByDetails('7', this.props.selectedWarehouse)
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.selectedCompany !== nextProps.selectedCompany && nextProps.selectedCompany) {
      this.props.fetchCustomers(() => {}, nextProps.selectedCompany && nextProps.selectedCompany.value);
    }
    if (this.props.selectedWarehouse !== nextProps.selectedWarehouse && nextProps.selectedWarehouse) {
      if (isVAK && Object.keys(nextProps.selectedWarehouse).length > 0) {
        this.fetchSalesOrdersByDetails(this.props.Days, nextProps.selectedWarehouse)
      }
    }
    const customerId = nextProps.Customers ? nextProps.Customers.id : null;

    if (nextProps.FromDate && nextProps.FromDate !== this.props.FromDate) {
      this.setState(
        {
          fromDate: nextProps.FromDate,
        },
        () => {
          this.fetchSalesOrdersByCustomerNum(customerId, nextProps.Days);
        },
      );
    }
    if (nextProps.ToDate && nextProps.ToDate !== this.props.ToDate) {
      this.setState(
        {
          toDate: nextProps.ToDate,
        },
        () => {
          this.fetchSalesOrdersByCustomerNum(customerId, nextProps.Days);
        },
      );
    }

    // let selectedChecker = false;
    // if(nextProps.salesInvoice ){
    //   console.log("CHECK");
    //   if(nextProps.salesInvoice.length){
    //     let selectedChecker = false;
    //     for (let i = 0; i < nextProps.salesInvoices.length; i++){
    //       if (nextProps.salesInvoices[i].isSelected)
    //         selectedChecker = true;
    //     }
    //   }
    // }
    // if (this.state.isSelected !== selectedChecker)
    //   this.setState({ isSelected: selectedChecker });

    if (nextProps.salesInvoice && nextProps.salesInvoice != this.props.salesInvoice) {
      let invoices = { ...this.state.invoices, rows: nextProps.salesInvoice, selectedRows: [] };
      // let selectedChecker = false;
      // let curRow = false;
      // if (this.state.curRow) {
      //     for (let i = 0; i < nextProps.salesInvoice.length; i++){
      //       if (nextProps.salesInvoices[i] == this.state.curRow)
      //         selectedChecker = true;
      //     }
      //     if (selectedChecker)
      //       curRow = this.state.curRow;
      // }
      this.setState({ invoices });
    }

    // If the Days field changes, update the sales invoices table and filters
    if (nextProps.Days && nextProps.Days !== this.props.Days) {
      if (nextProps.Days !== '-1') {
        this.props.setValue('customerReturn', 'FromDate', null);
        this.props.setValue('customerReturn', 'ToDate', null);
      }
      this.props.setValue('customerReturn', 'Days', nextProps.Days);
      this.fetchSalesOrdersByCustomerNum(customerId, nextProps.Days);
    }
    if (nextProps.Days === undefined) {
      this.props.setDefaultDays('customerReturn');
    }

    if (nextProps.Status && nextProps.Status !== this.props.Status) {
      if (nextProps.Customers) {
        // this.props.fetchSalesInvoicesCompleted(nextProps.Customers.id);
        this.fetchSalesOrdersByCustomerNum(nextProps.Customers.id, nextProps.Days);
      }
    }

    if (nextProps.Customers && nextProps.Customers !== this.props.Customers) {
      // this.props.fetchSalesInvoicesCompleted(nextProps.Customers.id);
      this.fetchSalesOrdersByCustomerNum(nextProps.Customers.id, nextProps.Days);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize(e) {
    this.setState({tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton});
  }

  formatDate(date) {
    return dateFormat('YYYY-MM-DD', date);
  }

  renderCustomers() {
    // If payment term is loading, show a spinner.
    if (this.props.customersIsLoading) return <Spinner />
    let customerNameOptions = this.getCustomerNameOptions();
    return (
      <div className="control-dropdown" style={{ width: '200px', marginRight: '15px' }}>
        <Field name="Customers" component={Selection} matchPos="any" options={customerNameOptions} />
      </div>
    );
  }

  renderCustomersNum() {
    // If payment term is loading, show a spinner.
    if (this.props.customersIsLoading) return <Spinner />
    let customerNameOptions = this.getCustomerNumOptions();
    return (
      <div className="control-dropdown" style={{ width: '150px', marginRight: '15px' }}>
        <Field name="Customers" component={Selection} matchPos="any" options={customerNameOptions} />
      </div>
    );
  }

  // clickNew(event) {
  //     event.preventDefault();
  //     const currentInvoice = this.state.invoices.selectedRows[0];
  //     this.props.resetCurrentSalesInvoice();
  //     this.props.selectSalesInvoice(currentInvoice);
  //     this.context.router.push('/customerReturn/new');
  // }

  handleKeyPress(e) {
    if (e.charCode === 13) {
      const currentInvoice = this.props.Invoice_num;
      this.props.resetCurrentSalesInvoice();
      this.props.selectSalesInvoice(currentInvoice);
      this.context.router.push('/customerReturn/new');
    }
  }

  renderInvoiceNumInput() {
    return (
      <div>
        <Row>
          <Col sm={2}>
            <label><Translate value="invoice" /> #: </label>
          </Col>
          <Col sm={2}>
            <Field name="Invoice_num" component={InputField} onKeyPress={(e) => this.handleKeyPress(e)}/>
          </Col>
        </Row>
      </div>
    );
  }

  renderDatePickers() {
    if (this.props.Days === -1) {
      return (
        <Row>
          <Col sm={1}>
            <label><Translate value="from" /></label>
          </Col>
          <Col sm={4}>
            <Field name="FromDate" component={DatePicker} />
          </Col>
          <Col sm={1}>
            <label><Translate value="to" /></label>
          </Col>
          <Col sm={4}>
            <Field name="ToDate" component={DatePicker} />
          </Col>
          <Col sm={2}>
            <Button className="btn btn-primary" onClick={() => { console.log('got Props', this.props); this.fetchSalesOrdersByDetails(); }}>
              <Translate value="submit" />
            </Button>
          </Col>
        </Row>
      );
    }
    return (
      <Row>
        <Col sm={10} />
        <Col sm={2}>
          <Button className="btn btn-primary" onClick={() => { console.log('got Props2', this.props); this.fetchSalesOrdersByDetails(); }}>
            <Translate value="submit" />
          </Button>
        </Col>
      </Row>
    );
  }

  fetchSalesOrdersByDetails(days, selectedWarehouseParam) {
    let dateRange = -1;
    let FromDate = '1900-01-01';
    let ToDate = '3000-01-01';
    // let CustomerNum = this.props.Customers && this.props.Customers.id;
    let InvoiceNum = this.props.InvoiceNum;
    // if(!CustomerNum) {
    //   confirm("choose a customer");
    //   return;
    // }
    if (this.state.fromDate != null) {
      FromDate = this.formatDate(this.state.fromDate);
    }
    if (this.state.toDate != null) {
      ToDate = this.formatDate(this.state.toDate);
    }
    if (this.props.Days != null) {
      dateRange = this.props.Days;
    }
    if(isVAK && days){
      dateRange = days
    }
    if (dateRange !== -1 && !isVAK || isVAK && dateRange !== -1 && dateRange !== '-1') {
      ToDate = moment().format('YYYY-MM-DD');
      if (dateRange === '1') {
        FromDate = ToDate;
      } else if (dateRange === '7') {
        FromDate = moment().subtract('7', 'days').format('YYYY-MM-DD');
      } else if (dateRange === '30') {
        FromDate = moment().subtract('30', 'days').format('YYYY-MM-DD');
      } else if (dateRange === '90') {
        FromDate = moment().subtract('90', 'days').format('YYYY-MM-DD');
      }
    }
    let Pickup_Warehouse_id_id
    // this.props.fetchSalesInvoicesCompleted(FromDate, ToDate, CustomerNum, dateRange, InvoiceNum);
    const customer = this.props.Customers;
    if (isVAK) {
      Pickup_Warehouse_id_id = selectedWarehouseParam && selectedWarehouseParam.value || this.props.selectedWarehouse.value
      this.props.fetchSalesInvoicesByNum(FromDate, ToDate, InvoiceNum, customer ? customer.id : null, Pickup_Warehouse_id_id);
    } else {
      this.props.fetchSalesInvoicesByNum(FromDate, ToDate, InvoiceNum, customer ? customer.id : null);
    }
  }


  fetchSalesOrdersByCustomerNum(CustomerNum, dateRange = -1) {
    let ToDate = moment().format('YYYY-MM-DD');
    let FromDate = moment().subtract('7', 'days').format('YYYY-MM-DD');
    // if (!CustomerNum) {
    //   confirm('Please Select a Customer');
    //   return;
    // }

    if (this.state.fromDate != null) FromDate = this.formatDate(this.state.fromDate);

    if (this.state.toDate != null) ToDate = this.formatDate(this.state.toDate);

    // if (this.props.Days != null) dateRange = this.props.Days;

    if (dateRange !== -1) {
      ToDate = moment().format('YYYY-MM-DD');
      if (dateRange === '1') {
        FromDate = ToDate;
      } else if (dateRange === '7') {
        FromDate = moment().subtract('7', 'days').format('YYYY-MM-DD');
      } else if (dateRange === '30') {
        FromDate = moment().subtract('30', 'days').format('YYYY-MM-DD');
      } else if (dateRange === '90') {
        FromDate = moment().subtract('90', 'days').format('YYYY-MM-DD');
      }
    }
  }

  getCustomerNameOptions() {
    const customerOptions = [];
    this.props.customers.map(customer => {
      customerOptions.push({ value: customer.CustomerNum, label: customer.Name, id: customer.Customer_id });
    });
    return customerOptions;
  }

  getCustomerNumOptions() {
    const customerOptions = [];
    this.props.customers.map(customer => {
      customerOptions.push({ value: customer.CustomerNum, label: customer.CustomerNum, id: customer.Customer_id });
    });
    return customerOptions;
  }

  renderInvoices() {
    if (this.props.isLoading && !this.props.error) {
      return <Spinner />;
    } else if (this.props.error) {
      return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.error)}</div></ContentWrapper>;
    }

    const tableHeight = (window.innerHeight < 900) ? 545 : 545;

    const getRows = () => {
      return Data.Selectors.getRows(this.state.invoices);
    };

    const getSize = () => {
      return getRows().length;
    };

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const onClearFilters = () => {
      // all filters removed
      let invoices = { ...this.state.invoices, filters: {} };
      this.setState({ invoices });
    }

    const handleFilterChange = filter => {
      let newFilters = Object.assign({}, this.state.invoices.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }

      let invoices = { ...this.state.invoices, filters: newFilters };
      this.setState({ invoices });
    };

    // Handle the sortable function

    const handleGridSort = (sortColumn, sortDirection) => {
      const invoices = { ...this.state.invoices, sortColumn, sortDirection };
      this.setState({ invoices });
    };

    const onRowsSelected = (rows) => {
      const newRows = getRows();
      const selectedRows = [];
      newRows.map((r) => {
        r.isSelected = false;
      });
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = true;
        selectedRows.push(r.row);
      });
      const invoices = { ...this.state.invoices, rows: newRows, selectedRows };
      this.setState({ invoices });
    };

    const onRowsDeselected = (rows) => {
      const newRows = this.state.invoices.rows;
      let curRow = false;
      rows.map((r) => {
        curRow = newRows[r.rowIdx];
        newRows[r.rowIdx].isSelected = false;
      });
      this.setState({ isSelected: false, curRow });
      let selectedRows = [...this.state.invoices.selectedRows];
      selectedRows = selectedRows.filter(function(obj) {
         return obj.isSelected == true;
      })
      let invoices = { ...this.state.invoices, rows: newRows, selectedRows };
      this.setState({ invoices });
    };

    const DateFormatter = React.createClass({
      render() {
        if (this.props.value) {
          const date = new Date(this.props.value);
          return <span>{date.toString().slice(4, 15)}</span>;
        }
        return <span className="label label-danger">-</span>;
      },
    });

    // Column difinition

    const columns = [
      {
        key: 'InvoiceNum',
        name: <Translate value="invoice_no" />,
        resizable: true,
        sortable: true,
        width: 160,
        filterable: true,
      },
      {
        key: 'SONum',
        name: <Translate value="linked_so_no" />,
        resizable: true,
        sortable: true,
        width: 160,
        filterable: true,
      },
      {
        key: 'Deliver_CustomerName',
        name: <Translate value="customer_name" />,
        resizable: true,
        sortable: true,
        width: 160,
        filterable: true,
      },
      {
        key: 'PostingDate',
        name: <Translate value="invoice_date" />,
        resizeable: true,
        sortable: true,
        width: 120,
        formatter: DateFormatter,
        filterable: true,
      },
      {
        key: 'TotalPrice',
        name: <Translate value="invoice_amount" />,
        resizable: true,
        sortable: true,
        width: 150,
        filterable: true,
        formatter: CashFormatter,
      },
      {
        key: 'FinalPrice',
        name: <Translate value="total" />,
        resizable: true,
        sortable: true,
        width: 140,
        filterable: true,
        formatter: CashFormatter,
      },
      {
        key: 'SaleStatus',
        name: <Translate value="invoice_type" />,
        resizable: true,
        sortable: true,
        width: 150,
        filterable: true,
      },
      ...(isSDR || isCRW || isSC) ? [{
        key: "PaymentType",
        name: <Translate value="payment_type" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 130,
      }] : [],
      ...(isSDR) ? [{
        key: "CloverLastFour",
        name: <Translate value="last_4" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 90,
      }] : [],
      {
        key: 'Pickup_Warehouse_id',
        name: <Translate value="warehouse" />,
        resizable: true,
        sortable: true,
        width: 150,
        filterable: true,
      },
    ];

    return (
      <Row>
        <Col sm={12}>
          <div id="CustomerReturn-dataGrid1">
            <ReactDataGrid
              rowKey="InvoiceNum"
              onGridSort={handleGridSort}
              toolbar={<Toolbar enableFilter={true} />}
              onAddFilter={handleFilterChange}
              onClearFilters={onClearFilters}
              columns={columns}
              rowHeight={25}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              minHeight={tableHeight}
              enableRowSelect="single"
              rowSelection={{
                showCheckbox: true,
                onRowsSelected,
                onRowsDeselected,
                selectBy: {
                  isSelectedKey: 'isSelected',
                },
              }}
            />
          </div>
        </Col>
      </Row>
    );
  }

  clickNew(event) {
    event.preventDefault();
    const currentInvoice = this.state.invoices.selectedRows[0];
    let customerToSelect;
    if (!this.props.Customers) {
      customerToSelect = {
        id: currentInvoice.Deliver_Customer_id,
      };
    } else {
      customerToSelect = this.props.Customers;
    }
    this.props.resetCurrentSalesInvoicePromise().then(() => {
      this.props.selectSalesInvoice(currentInvoice);
      this.props.selectCustomer(customerToSelect);
      this.context.router.push('/customerReturn/new');
    });
  }

  issueCredit(event) {
    event.preventDefault();
    // const currentInvoice = this.state.invoices.selectedRows[0];
    this.props.resetCurrentSalesInvoice();
    if(isGGI) {
      this.props.fetchBaseUsers()
    }
    // this.props.selectSalesInvoice(currentInvoice);
    this.props.selectCustomer(this.props.Customers);
    this.context.router.push('/customerIssueCredit');
  }

  render() {
    let CustomerId = 0;
    if (this.props.Customers) { CustomerId = this.props.Customers.id; }
    let searchNoStyle={'border-left': '1px solid #D3D3D3', 'padding-left': '10px', marginRight: '10px'}
    return (
      //---------------
      // Begin HTML: Create New/Edit return
      //---------------
      <ContentWrapper>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="returns" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="new_sales_return" />
          </Breadcrumb.Item>
        </Breadcrumb>
        {/* <div className="content-heading"><Translate value="customer_return" /></div> */}
        <Grid id="returns-customer-return">
          <Row>
            <Col xs={12}>
              <Panel id="date-range-picker" className="form-horizontal">
                <Row>
                  {
                    /* <Col xs={ 1 }>
                      <h3 className="filter-title"><Translate value="order_type" /><span className="colon">:</span></h3>
                    </Col>
                    <Col xs={ 11 }>
                      <div id="statusFilterRadios" className="form-horizontal">
                        <Field name="Status" component={ renderStatusRadios }  />
                      </div>
                    </Col> */
                  }
                  <Col xs={1}>
                    <h3 className="filter-title text-nowrap">
                      <Translate value="return_date" />
                      <span className="colon">:</span>
                    </h3>
                  </Col>
                  <Col xs={11}>
                    <div id="statusFilterRadios" className="form-horizontal">
                      <Field
                        name="Days"
                        component={renderRadios}
                        CustomerId={CustomerId}
                        Days={this.props.Days}
                        fetchSalesOrdersByCustomerNum={this.fetchSalesOrdersByCustomerNum}
                      />
                    </div>
                  </Col>
                </Row>
              </Panel>
            </Col>
          </Row>
          <Panel className="position-relative table-collapse-fix" style={{ height: '620px' }}>
            <div className="table-filters" style={{ width: '650px', zIndex: 1, left: '20px', 'border-right': '1px solid #D3D3D3' }}>
              <label className="control-label" style={{ whiteSpace: 'nowrap', width: '100px' }}><Translate value="customer_name" /></label>
              { this.renderCustomers() }
              <label className="control-label" style={{ whiteSpace: 'nowrap', width: '60px', marginRight: '5px' }}><Translate value="number" /></label>
              { this.renderCustomersNum() }
              <div className="control-dropdown" style={isVAK ? { width: '220px', ...searchNoStyle } : searchNoStyle}>
                <Field name="InvoiceNum" component={InputField} placeholder={isVAK ? I18n.t('invoice_or_serial_no') : "Invoice No."} />
              </div>
              <ButtonToolbar>
                <Button bsStyle="primary" onClick={() => { this.fetchSalesOrdersByDetails(); }}>
                  <em className="fa fa-search" />
                </Button>
              </ButtonToolbar>
            </div>
            <ButtonToolbar className="table-buttons" style={{ left: '730px' }}>
              <Button
                onClick={(event) => { this.clickNew(event); }}
                bsStyle="success"
                disabled={!checkPermission('add_sales_return') || !this.state.invoices.selectedRows.length}
              >
                <Translate value="create_sales_return" />
              </Button>
              <Button
                onClick={(event) => { this.issueCredit(event); }}
                disabled={!checkPermission('add_sales_return') || this.props.Customers == null}
              >
                <Translate value="issue_credit" />
              </Button>
            </ButtonToolbar>
            { this.renderInvoices() }
          </Panel>
        </Grid>
      </ContentWrapper>
    );
  }
}

export default CustomerReturn;



// WEBPACK FOOTER //
// ./master/jsx/components/Returns/customerReturn.jsx